import { render, staticRenderFns } from "./customDesign.vue?vue&type=template&id=38b50ea1"
import script from "./customDesign.vue?vue&type=script&lang=js"
export * from "./customDesign.vue?vue&type=script&lang=js"
import style0 from "./customDesign.vue?vue&type=style&index=0&id=38b50ea1&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports